import { render } from "./EnquireAlumni.vue?vue&type=template&id=7db51c8c&lang=true"
import script from "./EnquireAlumni.vue?vue&type=script&lang=js"
export * from "./EnquireAlumni.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__